import axios from '@/libs/api.request'


export const getAllAccountList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAllAccountList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getDefaultCityDemandList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getDefaultCityDemandList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const saveSingleDefaultDemand = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveSingleDefaultDemand',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getCidTypeList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getCidTypeList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const saveAllDemand = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveAllDemand',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getToutiaoAdvDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getToutiaoAdvDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getToutiaoSrc = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getToutiaoSrc',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getAdidData = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdidData',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getAllTypeStatic = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAllTypeStatic',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getAdvTypeGroupByCityStaticList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdvTypeGroupByCityStaticList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getAdvCityList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdvCityList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getAllOperationList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAllOperationList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getTimeCycleStatic = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getTimeCycleStatic',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getAccountStatic = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAccountStatic',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}


export const accountManage = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/accountManage',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getAccount = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAccount',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getAllOperater = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAllOperater',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addAccount = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/addAccount',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const saveAccountStatusOpen = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveAccountStatusOpen',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const delAccount = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/delAccount',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const saveDemandCover = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveDemandCover',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getDateList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getDateList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const saveOperaterReport = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveOperaterReport',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getOperaterLogList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getOperaterLogList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getLogDetail = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getLogDetail',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getOldSystemId = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getOldSystemId',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getOperaterStatic = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getOperaterStatic',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getAdvPageList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdvPageList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const addAdvPage = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/addAdvPage',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getAdvPge = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdvPge',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const delAdvPage = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/delAdvPage',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getFormTypeList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getFormTypeList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const addFormType = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/addFormType',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getFormType = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getFormType',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const delFormType = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/delFormType',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getDamandDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getDamandDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getDamandReportByDayList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getDamandReportByDayList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getSucaiDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getSucaiDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getSucaiIdCostListByID = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getSucaiIdCostListByID',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getWechatAdvDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getWechatAdvDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getWechatAdidData = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getWechatAdidData',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const editDemandToZero = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/editDemandToZero',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const stopCityDemand = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/stopCityDemand',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getCostTrends = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getCostTrends',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getPushDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getPushDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getSystemDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getSystemDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getInterList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getInterList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const saveInterStatus = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveInterStatus',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getInter = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getInter',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const saveInter = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveInter',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const getClientList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getClientList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getSrcIdList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getSrcIdList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const addSrcId = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/addSrcId',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getSrcId = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getSrcId',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const delSrcId = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/delSrcId',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getAdvHistoryDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdvHistoryDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getAdidDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdidDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getAdplanList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdplanList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const saveSingleAdplan = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveSingleAdplan',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getAdplan = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getAdplan',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const delAdplan = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/delAdplan',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getadPlanIndexStandardList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getadPlanIndexStandardList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

export const saveSingleadPlanIndexStandard = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveSingleadPlanIndexStandard',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getadPlanIndexStandard = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getadPlanIndexStandard',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const deladPlanIndexStandard = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/deladPlanIndexStandard',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const saveAdStatusOpen = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/saveAdStatusOpen',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getWechatSrc = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getWechatSrc',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getRong360DataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getRong360DataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getCkhAdvDataList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/adv_manage/getCkhAdvDataList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}






